import { render, staticRenderFns } from "./Doctor.vue?vue&type=template&id=2148e019&"
import script from "./Doctor.vue?vue&type=script&lang=js&"
export * from "./Doctor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports